import styled from '@emotion/styled';

export const Content = styled.div`
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.neutrals.white};
    border: solid 1px ${theme.colors.neutrals.grey8};
    padding: ${theme.spacing(3)};
  `}
`;
